import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const [enabled] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(pointer: fine)").matches
  );
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const rx = useSpring(x, { stiffness: 280, damping: 24, mass: 0.6 });
  const ry = useSpring(y, { stiffness: 280, damping: 24, mass: 0.6 });

  useEffect(() => {
    if (!enabled) return;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      setHovering(!!e.target.closest("a,button,[data-cursor]"));
    };
    window.addEventListener("mousemove", move);
    document.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
    };
  }, [enabled, x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        data-testid="custom-cursor-dot"
        className="pointer-events-none fixed left-0 top-0 z-[80] h-2 w-2 rounded-full bg-[#FFD700]"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
      />
      <motion.div
        data-testid="custom-cursor-ring"
        className="pointer-events-none fixed left-0 top-0 z-[80] rounded-full border border-[#D4AF37]/60"
        style={{ x: rx, y: ry, translateX: "-50%", translateY: "-50%" }}
        animate={{
          width: hovering ? 52 : 32,
          height: hovering ? 52 : 32,
          opacity: hovering ? 1 : 0.6,
          backgroundColor: hovering ? "rgba(212,175,55,0.08)" : "rgba(212,175,55,0)",
        }}
        transition={{ duration: 0.25 }}
      />
    </>
  );
}
